<template>
  <div class="share-btn mt4">
    <img :src="btnUrl" alt="" />
    <div class="share-text" :style="{ color: customerPaperwork.btnColor }">
      <slot></slot>
    </div>
    <img
      class="bargain-btn-icon"
      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/xhs-sweep-light.png"
      alt=""
    />
  </div>
</template>
<script>
export default {
  props: {
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    btnUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.share-btn {
  position: relative;
  width: 175px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px 50px 50px 50px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 50px 50px 50px 50px;
  }
  .share-text {
    color: #8e5014;
    font-size: 12px;
    position: relative;
    z-index: 10;
  }
  .bargain-btn-icon {
    position: absolute;
    left: 0;
    bottom: 0;
    animation: identifier 2s infinite;
    border-radius: 50px;
  }
  @keyframes identifier {
    0% {
      transform: translateX(-60px);
    }
    100% {
      transform: translateX(calc(100% - 55px));
    }
  }
}
</style>
